@if (appUpdateService.mobileUpdate(); as update) {
<app-force-update
  [required]="update.required"
  (dismiss)="appUpdateService.dismissMobileUpdate()"
></app-force-update>
} @if (logged && !isRouteLayoutTransitionPending && !isAdminRoute &&
!isOnboardingRoute && !isLegalCompletionRoute && !isAccountActivationRoute &&
!isPublicWorkRoute) { @if (isMobile && !isCompassRecommendationsTunnelRoute) {
<app-header-mobile [user]="user"></app-header-mobile>
} @else if (!isCompassRecommendationsTunnelRoute) {
<app-navbar [user]="user"></app-navbar>
<app-header [user]="user"></app-header>
} @if (isMobile) {
<app-navbar-mobile [user]="user"></app-navbar-mobile>
} }

<main [ngClass]="mainClasses">
  <div
    data-route-scroll-content
    [class.invisible]="isRouteLayoutTransitionPending"
    [class.pointer-events-none]="isRouteLayoutTransitionPending"
  >
    <router-outlet></router-outlet>
  </div>
  @if (isRouteLayoutTransitionPending) {
  <section
    class="app-route-transition-splash"
    aria-busy="true"
    aria-live="polite"
  >
    <dotlottie-player
      src="/assets/images/icons/gem-1.json"
      autoplay
      loop
      background="transparent"
      class="app-route-transition-splash__animation"
      aria-hidden="true"
    ></dotlottie-player>
    <img
      src="/assets/images/icons/gemster-logo-typo.svg"
      alt="Gemster"
      class="app-route-transition-splash__logo"
    />
    <p class="app-route-transition-splash__label">
      {{ "SPLASH_LOADING" | translate }}
    </p>
  </section>
  } @if (logged && user) {
  <app-news-modal
    [userId]="user._id"
    [enabled]="
      !isRouteLayoutTransitionPending &&
      !isAdminRoute &&
      !isOnboardingRoute &&
      !isLegalCompletionRoute &&
      !isAccountActivationRoute &&
      !isCompassRecommendationsTunnelRoute &&
      !!user.onboardedAt
    "
  ></app-news-modal>
  } @if (logged && user && !isLegalCompletionRoute) {
  <app-founder-premium-modal
    [modalId]="founderPremiumModalId"
    [isMobile]="isMobile"
    (continueRequested)="dismissFounderPremiumModal()"
  ></app-founder-premium-modal>
  } @if (logged) { @if (isMobile) {
  <app-modal [modalId]="'profile'" classes="!z-[100] !rounded-none"
    ><app-profile [isMobile]="true" [user]="user!"></app-profile
  ></app-modal>
  <app-modal
    [modalId]="'notifications'"
    (modalClosed)="onNotificationsModalClosed()"
    classes="!z-[100] !rounded-none"
  >
    <app-notifications-list
      [user]="user!"
      [isOpened]="isNotificationsModalOpened"
      [isMobile]="isMobile"
    ></app-notifications-list>
  </app-modal>
  }
  <app-modal
    modalId="addWork"
    [classes]="
      isMobile
        ? '!rounded-none'
        : '!w-[calc(100%-48px)] !max-w-[1200px] !max-h-[calc(100dvh-48px)]'
    "
    [containerClasses]="
      isMobile ? '!pt-[calc(var(--sat)+20px)] [&>.close]:hidden' : ''
    "
    [overflowY]="true"
  >
    <app-add-work></app-add-work>
  </app-modal>
  @if (user && addWorkRatingPromptWork) {
  <app-modal
    [modalId]="'add_work_quick_rating_prompt'"
    (modalClosed)="onAddWorkRatingPromptClosed()"
    [classes]="
      isMobile
        ? '!z-[120] !h-auto bottom-0 rounded-t-lg modal-no-transform-blur'
        : '!z-[120] !h-auto !max-w-[560px] !rounded-lg modal-no-transform-blur'
    "
    overlayClasses="!z-[110]"
    rootClasses="!z-[120]"
    [shouldSwipeDownToClose]="true"
  >
    <app-work-quick-rating
      [userId]="user._id"
      [work]="addWorkRatingPromptWork"
      [language]="user.language"
      doneTitleKey="WORK_COMPANION_RATING_TITLE"
      [ratingPromptContext]="addWorkRatingPromptContext"
      [saveRating]="addWorkRatingSubmit"
      [autoCloseOnSuccessMs]="addWorkRatingSubmit ? 0 : 3000"
      [showRemoveLink]="!addWorkRatingSubmit"
      (rated)="onAddWorkQuickRated($event)"
      (requestClose)="closeModal('add_work_quick_rating_prompt')"
      (requestRemove)="onAddWorkRatingPromptRemove()"
    ></app-work-quick-rating>
  </app-modal>
  } @if (user && addWorkCompletionPromptWork) {
  <app-modal
    [modalId]="'add_work_quick_completion_prompt'"
    (modalClosed)="onAddWorkCompletionPromptClosed()"
    [classes]="
      isMobile
        ? '!z-[120] !h-[90dvh] !max-h-[min(90dvh,860px)] bottom-0 rounded-t-lg modal-no-transform-blur'
        : '!z-[120] !h-[85dvh] !max-h-[min(85dvh,860px)] !max-w-[560px] !rounded-lg modal-no-transform-blur'
    "
    containerClasses="!overflow-hidden"
    overlayClasses="!z-[110]"
    rootClasses="!z-[120]"
    [shouldSwipeDownToClose]="true"
  >
    <app-work-quick-completion
      class="block h-full min-h-0"
      [user]="user"
      [work]="addWorkCompletionPromptWork"
      [language]="user.language"
      (workUpdated)="onAddWorkQuickCompleted($event)"
      (requestRemove)="onAddWorkCompletionPromptRemove()"
    ></app-work-quick-completion>
  </app-modal>
  } @if (user && addWorkCompletionPromptWork) {
  <app-modal
    [modalId]="'quick_completion_companion_' + addWorkCompletionPromptWork._id"
    [classes]="
      isMobile
        ? 'worksDetailsModal !z-[140] !rounded-none'
        : 'worksDetailsModal !z-[140] !h-[80vh] !max-h-[760px] !max-w-[760px] !rounded-lg'
    "
    [rootClasses]="isMobile ? 'worksDetailsModalRoot !z-[140]' : '!z-[140]'"
    overlayClasses="!z-[130]"
    [shouldSwipeDownToClose]="true"
    (modalClosed)="quickCompletionCompanionModal.resetFlow()"
  >
    <app-works-companion
      #quickCompletionCompanionModal
      [item]="addWorkCompletionPromptWork"
      [user]="user"
      [mode]="'modalContent'"
      [modalIdOverride]="
        'quick_completion_companion_' + addWorkCompletionPromptWork._id
      "
    ></app-works-companion>
  </app-modal>
  }
  <app-modal
    modalId="addList"
    class="block relative !z-[100]"
    [classes]="
      isMobile
        ? '!z-[100] !h-auto bottom-0 rounded-t-lg'
        : '!z-[100] !max-w-[600px] !h-auto !rounded-lg'
    "
    #createListModal
    [shouldSwipeDownToClose]="true"
  >
    <app-create-list [user]="user!"></app-create-list>
  </app-modal>
  @if (item) {
  <app-modal
    [modalId]="item._id"
    [classes]="
      isMobile ? 'worksDetailsModal !rounded-none' : 'worksDetailsModal'
    "
    rootClasses="worksDetailsModalRoot"
    [stickyTitle]="getWorkDetailsStickyTitle(item)"
    [overflowY]="true"
    [workNavigationState]="workModalNavigationService.state$ | async"
    [workNavigationTransitioning]="
      (workModalNavigationService.isTransitioning$ | async) ?? false
    "
    (workNavigationRequested)="
      workModalNavigationService.requestNavigation($event)
    "
  >
    <app-work-details-navigation>
      <app-public-work-context [item]="item" />
      <ng-container
        *ngTemplateOutlet="
          detailsTemplate;
          context: {
            $implicit: item,
            list: list,
            fullyLoaded: fullyLoaded,
            detailsPreloaded: detailsPreloaded,
            otherUser: otherUser,
            friend: friend
          }
        "
      ></ng-container>
    </app-work-details-navigation>

    <ng-template
      #detailsTemplate
      let-item
      let-list="list"
      let-fullyLoaded="fullyLoaded"
      let-detailsPreloaded="detailsPreloaded"
    >
      @if (detailsComponent) { @for (modalItem of [item]; track modalItem._id) {
      <ng-container
        *ngComponentOutlet="
          detailsComponent;
          inputs: {
            item: modalItem,
            list: list,
            fullyLoaded: fullyLoaded,
            detailsPreloaded: detailsPreloaded,
            otherUser: otherUser,
            friend: friend
          }
        "
      ></ng-container>
      } }
    </ng-template>
  </app-modal>
  <app-modal
    [modalId]="'dlt_' + item._id"
    [classes]="
      isMobile ? '!h-auto bottom-0 rounded-t-lg' : '!h-auto max-w-[560px]'
    "
    [shouldSwipeDownToClose]="true"
  >
    @if (!list || otherUser) {
    <h2 class="text-center">
      {{ "DELETE_WORK" | translate }}
    </h2>
    <p class="text-center font-bold mb-2">
      {{ worksService.getItemTitle(item) }}
    </p>
    <img
      crossorigin="anonymous"
      [src]="worksService.getItemCover(item, '', false)"
      [alt]="worksService.getItemTitle(item)"
      class="block max-w-[200px] max-h-[300px] m-auto mb-5 rounded-lg"
    />
    <div
      class="flex justify-end items-center uppercase font-bold cursor-pointer text-[16px] mr-2"
    >
      <button
        (click)="closeModal('dlt_' + item._id)"
        (keyup)="
          onKeyUp($event, 'closeModal', undefined, undefined, 'dlt_' + item._id)
        "
        tabindex="0"
        class="uppercase"
      >
        {{ "HELL_NO" | translate }}
      </button>
      <button
        (click)="remove(item, $event)"
        (keyup)="
          onKeyUp($event, 'remove', undefined, undefined, undefined, item)
        "
        tabindex="0"
        class="ml-4 text-primary-text uppercase"
      >
        {{ deleteConfirmLabel | translate }}
      </button>
    </div>
    } @else {
    <h2 class="text-center">
      {{ "DELETE_WORK_COLLECTION" | translate }}
    </h2>
    <p class="text-center font-bold">
      {{ worksService.getItemTitle(item) }}
    </p>
    <img
      crossorigin="anonymous"
      [src]="worksService.getItemCover(item, '', false)"
      [alt]="worksService.getItemTitle(item)"
      class="block max-w-[200px] max-h-[300px] m-auto mb-5"
    />
    <div
      class="flex justify-end items-center uppercase font-bold cursor-pointer text-[16px]"
    >
      <button
        (click)="closeModal('dlt_' + item._id)"
        (keyup)="
          onKeyUp($event, 'closeModal', undefined, undefined, 'dlt_' + item._id)
        "
        tabindex="0"
        class="uppercase"
      >
        {{ "HELL_NO" | translate }}
      </button>
      <button
        (click)="remove(item, $event, list)"
        (keyup)="
          onKeyUp($event, 'remove', undefined, undefined, undefined, item, list)
        "
        tabindex="0"
        class="ml-4 text-primary-text uppercase"
      >
        {{ deleteConfirmLabel | translate }}
      </button>
    </div>
    }
  </app-modal>
  <app-modal
    [modalId]="'clear_rating_' + item._id"
    [classes]="
      isMobile ? '!h-auto bottom-0 rounded-t-lg' : '!h-auto max-w-[560px]'
    "
    [shouldSwipeDownToClose]="true"
  >
    <h2 class="text-center">
      {{ "CLEAR_RATING_CONFIRMATION" | translate }}
    </h2>
    <p class="text-center font-bold">
      {{ worksService.getItemTitle(item) }}
    </p>
    <div
      class="mt-5 flex items-center justify-end text-[16px] font-bold uppercase"
    >
      <button
        type="button"
        class="uppercase"
        [disabled]="isClearingRating"
        (click)="closeModal('clear_rating_' + item._id)"
      >
        {{ "HELL_NO" | translate }}
      </button>
      <button
        type="button"
        class="ml-4 uppercase text-form-error disabled:cursor-wait disabled:opacity-60 dark:text-form-errorLight"
        [disabled]="isClearingRating"
        (click)="clearRating(item)"
      >
        {{ (isClearingRating ? "DELETING" : "YES_PLEASE") | translate }}
      </button>
    </div>
  </app-modal>
  @if (item.type === worksTypes.Series) {
  <app-modal
    [modalId]="'confirm_progress_series_' + item._id"
    [classes]="
      isMobile ? '!h-[300px] bottom-0 rounded-t-lg' : '!h-[280px] max-w-[560px]'
    "
    [shouldSwipeDownToClose]="true"
  >
    <h2 class="text-center px-2">
      {{ "GOING_BACKWARD" | translate }}
    </h2>
    <p class="text-center mb-5">
      {{ "CONFIRM_BACKWARD_SERIES" | translate }}
    </p>
    <div
      class="flex justify-end items-center uppercase font-bold cursor-pointer text-[16px]"
    >
      <button
        (click)="seriesService.backwardProgress = false"
        (keyup)="onKeyUp($event, 'backwardProgress', false, worksTypes.Series)"
        tabindex="0"
        class="uppercase"
      >
        {{ "NO_MY_BAD" | translate }}
      </button>
      <button
        (click)="seriesService.backwardProgress = true"
        (keyup)="onKeyUp($event, 'backwardProgress', true, worksTypes.Series)"
        tabindex="0"
        class="ml-2 text-primary-text uppercase"
      >
        {{ "YES_PLEASE" | translate }}
      </button>
    </div>
  </app-modal>
  } @if (item.type === worksTypes.Book) {
  <app-modal
    [modalId]="'confirm_progress_book_' + item._id"
    [classes]="
      isMobile ? '!h-[300px] bottom-0 rounded-t-lg' : '!h-[280px] max-w-[560px]'
    "
    [shouldSwipeDownToClose]="true"
  >
    <h2 class="text-center px-2">
      {{ "GOING_BACKWARD" | translate }}
    </h2>
    <p class="text-center mb-5">
      {{ "CONFIRM_BACKWARD" | translate }}
    </p>
    <div
      class="flex justify-end items-center uppercase font-bold cursor-pointer text-[16px]"
    >
      <button
        (click)="bookService.backwardProgress = false"
        (keyup)="onKeyUp($event, 'backwardProgress', false, worksTypes.Book)"
        tabindex="0"
        class="uppercase"
      >
        {{ "NO_MY_BAD" | translate }}
      </button>
      <button
        (click)="bookService.backwardProgress = true"
        (keyup)="onKeyUp($event, 'backwardProgress', true, worksTypes.Book)"
        tabindex="0"
        class="ml-2 text-primary-text uppercase"
      >
        {{ "YES_PLEASE" | translate }}
      </button>
    </div>
  </app-modal>
  } @if (item.type === worksTypes.Game) {
  <app-modal
    [modalId]="'confirm_progress_game_' + item._id"
    [classes]="
      isMobile ? '!h-[300px] bottom-0 rounded-t-lg' : '!h-[280px] max-w-[560px]'
    "
    [shouldSwipeDownToClose]="true"
  >
    <h2 class="text-center px-2">
      {{ "GOING_BACKWARD" | translate }}
    </h2>
    <p class="text-center mb-5">
      {{ "CONFIRM_BACKWARD" | translate }}
    </p>
    <div
      class="flex justify-end items-center uppercase font-bold cursor-pointer text-[16px]"
    >
      <button
        (click)="gameService.backwardProgress = false"
        (keyup)="onKeyUp($event, 'backwardProgress', false, worksTypes.Game)"
        tabindex="0"
        class="uppercase"
      >
        {{ "NO_MY_BAD" | translate }}
      </button>
      <button
        (click)="gameService.backwardProgress = true"
        (keyup)="onKeyUp($event, 'backwardProgress', true, worksTypes.Game)"
        tabindex="0"
        class="ml-2 text-primary-text uppercase"
      >
        {{ "YES_PLEASE" | translate }}
      </button>
    </div>
  </app-modal>
  } @if (item.type === worksTypes.Manga) {
  <app-modal
    [modalId]="'confirm_progress_manga_' + item._id"
    [classes]="
      isMobile ? '!h-[330px] bottom-0 rounded-t-lg' : '!h-[300px] max-w-[560px]'
    "
    [shouldSwipeDownToClose]="true"
  >
    <h2 class="text-center px-2">
      {{ "GOING_BACKWARD_VOLUME" | translate }}
    </h2>
    <p class="text-center mb-5">
      {{ "CONFIRM_BACKWARD" | translate }}
    </p>
    <div
      class="flex justify-end items-center uppercase font-bold cursor-pointer text-[16px]"
    >
      <button
        (click)="
          mangaService.backwardProgress = {
            id: item._id + volume?.volumeNumber,
            goBackward: false
          }
        "
        (keyup)="
          onKeyUp(
            $event,
            'backwardProgress',
            {
              id: item._id + volume?.volumeNumber,
              goBackward: false
            },
            worksTypes.Manga
          )
        "
        tabindex="0"
        class="uppercase"
      >
        {{ "NO_MY_BAD" | translate }}
      </button>
      <button
        (click)="
          mangaService.backwardProgress = {
            id: item._id + volume?.volumeNumber,
            goBackward: true
          }
        "
        (keyup)="
          onKeyUp(
            $event,
            'backwardProgress',
            {
              id: item._id + volume?.volumeNumber,
              goBackward: true
            },
            worksTypes.Manga
          )
        "
        tabindex="0"
        class="ml-2 text-primary-text uppercase"
      >
        {{ "YES_PLEASE" | translate }}
      </button>
    </div>
  </app-modal>
  } @if (item.type === worksTypes.Manga) {
  <app-modal
    [modalId]="'confirm_progress_mangas_' + item._id"
    [classes]="
      isMobile ? '!h-[330px] bottom-0 rounded-t-lg' : '!h-[300px] max-w-[560px]'
    "
    [shouldSwipeDownToClose]="true"
  >
    <h2 class="text-center px-2">
      {{ "GOING_BACKWARD_ALL_VOLUMES" | translate }}
    </h2>
    <p class="text-center mb-5">
      {{ "CONFIRM_BACKWARD" | translate }}
    </p>
    <div
      class="flex justify-end items-center uppercase font-bold cursor-pointer text-[16px]"
    >
      <button
        (click)="
          mangaService.backwardProgressAll = {
            id: item._id,
            goBackward: false
          }
        "
        (keyup)="
          onKeyUp(
            $event,
            'backwardProgressAll',
            {
              id: item._id,
              goBackward: false
            },
            worksTypes.Manga
          )
        "
        tabindex="0"
        class="uppercase"
      >
        {{ "NO_MY_BAD" | translate }}
      </button>
      <button
        (click)="
          mangaService.backwardProgressAll = {
            id: item._id,
            goBackward: true
          }
        "
        (keyup)="
          onKeyUp(
            $event,
            'backwardProgressAll',
            {
              id: item._id,
              goBackward: true
            },
            worksTypes.Manga
          )
        "
        tabindex="0"
        class="ml-2 text-primary-text uppercase"
      >
        {{ "YES_PLEASE" | translate }}
      </button>
    </div>
  </app-modal>
  } @if (item.type === worksTypes.Comic) {
  <app-modal
    [modalId]="'confirm_progress_comic_' + item._id"
    [classes]="
      isMobile ? '!h-[330px] bottom-0 rounded-t-lg' : '!h-[300px] max-w-[560px]'
    "
    [shouldSwipeDownToClose]="true"
  >
    <h2 class="text-center px-2">
      {{ "GOING_BACKWARD_VOLUME" | translate }}
    </h2>
    <p class="text-center mb-5">
      {{ "CONFIRM_BACKWARD" | translate }}
    </p>
    <div
      class="flex justify-end items-center uppercase font-bold cursor-pointer text-[16px]"
    >
      <button
        (click)="
          comicService.backwardProgress = {
            id: item._id + volume?.volumeNumber,
            goBackward: false
          }
        "
        (keyup)="
          onKeyUp(
            $event,
            'backwardProgress',
            {
              id: item._id + volume?.volumeNumber,
              goBackward: false
            },
            worksTypes.Comic
          )
        "
        tabindex="0"
        class="uppercase"
      >
        {{ "NO_MY_BAD" | translate }}
      </button>
      <button
        (click)="
          comicService.backwardProgress = {
            id: item._id + volume?.volumeNumber,
            goBackward: true
          }
        "
        (keyup)="
          onKeyUp(
            $event,
            'backwardProgress',
            {
              id: item._id + volume?.volumeNumber,
              goBackward: true
            },
            worksTypes.Comic
          )
        "
        tabindex="0"
        class="ml-2 text-primary-text uppercase"
      >
        {{ "YES_PLEASE" | translate }}
      </button>
    </div>
  </app-modal>
  } @if (item.type === worksTypes.Comic) {
  <app-modal
    [modalId]="'confirm_progress_comics_' + item._id"
    [classes]="
      isMobile ? '!h-[330px] bottom-0 rounded-t-lg' : '!h-[300px] max-w-[560px]'
    "
    [shouldSwipeDownToClose]="true"
  >
    <h2 class="text-center px-2">
      {{ "GOING_BACKWARD_ALL_VOLUMES" | translate }}
    </h2>
    <p class="text-center mb-5">
      {{ "CONFIRM_BACKWARD" | translate }}
    </p>
    <div
      class="flex justify-end items-center uppercase font-bold cursor-pointer text-[16px]"
    >
      <button
        (click)="
          comicService.backwardProgressAll = {
            id: item._id,
            goBackward: false
          }
        "
        (keyup)="
          onKeyUp(
            $event,
            'backwardProgressAll',
            {
              id: item._id,
              goBackward: false
            },
            worksTypes.Comic
          )
        "
        tabindex="0"
        class="uppercase"
      >
        {{ "NO_MY_BAD" | translate }}
      </button>
      <button
        (click)="
          comicService.backwardProgressAll = {
            id: item._id,
            goBackward: true
          }
        "
        (keyup)="
          onKeyUp(
            $event,
            'backwardProgressAll',
            {
              id: item._id,
              goBackward: true
            },
            worksTypes.Comic
          )
        "
        tabindex="0"
        class="ml-2 text-primary-text uppercase"
      >
        {{ "YES_PLEASE" | translate }}
      </button>
    </div>
  </app-modal>
  } @if (user && currentModalId === 'e_games_d_' + item._id) {
  <app-modal
    [modalId]="'e_games_d_' + item._id"
    classes="!h-auto bottom-0 mobile:bottom-auto mobile:!max-w-[660px] rounded-t-lg mobile:!rounded-lg"
    containerClasses="!h-auto !max-h-[90dvh] !overflow-y-auto !p-3 mobile:!p-4"
    [shouldSwipeDownToClose]="true"
  >
    @if (item.type === worksTypes.Game) {
    <app-edit-game-dates [item]="item" [user]="user"></app-edit-game-dates>
    }
  </app-modal>
  } @if (user && currentModalId === 'e_books_d_' + item._id) {
  <app-modal
    [modalId]="'e_books_d_' + item._id"
    classes="!h-auto bottom-0 mobile:bottom-auto mobile:!max-w-[660px] rounded-t-lg mobile:!rounded-lg"
    containerClasses="!h-auto !max-h-[90dvh] !overflow-y-auto !p-3 mobile:!p-4"
    [shouldSwipeDownToClose]="true"
  >
    @if (item.type === worksTypes.Book) {
    <app-edit-book-dates [item]="item" [user]="user"></app-edit-book-dates>
    }
  </app-modal>
  } @if (user && currentModalId === 'e_series_d_' + item._id) {
  <app-modal
    [modalId]="'e_series_d_' + item._id"
    [classes]="
      isMobile
        ? '!h-full bottom-0 rounded-t-lg overflow-scroll'
        : '!h-[560px] max-w-[660px] !rounded-lg overflow-scroll'
    "
  >
    @if (item.type === worksTypes.Series) {
    <app-edit-series-dates [item]="item" [user]="user"></app-edit-series-dates>
    }
  </app-modal>
  } @if (user && currentModalId === 'e_comics_d_' + item._id) {
  <app-modal
    [modalId]="'e_comics_d_' + item._id"
    [classes]="
      isMobile
        ? '!h-full bottom-0 rounded-t-lg overflow-scroll'
        : '!h-[560px] max-w-[660px] !rounded-lg overflow-scroll'
    "
  >
    @if (item.type === worksTypes.Comic) {
    <app-edit-volumes-dates
      [item]="item"
      [user]="user"
    ></app-edit-volumes-dates>
    }
  </app-modal>
  } @if (user && currentModalId === 'e_mangas_d_' + item._id) {
  <app-modal
    [modalId]="'e_mangas_d_' + item._id"
    [classes]="
      isMobile
        ? '!h-full bottom-0 rounded-t-lg overflow-scroll'
        : '!h-[560px] max-w-[660px] !rounded-lg overflow-scroll'
    "
  >
    @if (item.type === worksTypes.Manga) {
    <app-edit-volumes-dates
      [item]="item"
      [user]="user"
    ></app-edit-volumes-dates>
    }
  </app-modal>
  } @if (currentModalId === 'ewd_' + item._id) {
  <app-modal
    [modalId]="'ewd_' + item._id"
    [classes]="
      isMobile
        ? '!h-[360px] bottom-0 rounded-t-lg'
        : '!h-[380px] max-w-[400px] !rounded-lg'
    "
    [shouldSwipeDownToClose]="true"
  >
    <app-edit-work-date [item]="item"></app-edit-work-date>
  </app-modal>
  } @if (user && currentModalId === 'worksCompanion_' + item._id) {
  <app-modal
    [modalId]="'worksCompanion_' + item._id"
    classes="worksDetailsModal !z-[100]"
    [overlayClasses]="'!z-[95]'"
    [shouldSwipeDownToClose]="true"
    (modalClosed)="worksCompanionModal.resetFlow()"
  >
    <app-works-companion
      #worksCompanionModal
      [item]="item"
      [user]="user"
      [mode]="'modalContent'"
    ></app-works-companion>
  </app-modal>
  } @if (currentModalId && currentModalId.startsWith('send_work_')) {
  <app-modal
    [modalId]="currentModalId"
    [classes]="
      isMobile
        ? '!h-[90%] !max-h-[90%] !min-h-0 bottom-0 !rounded-t-2xl modal-no-transform-blur'
        : sendWorkDesktopClasses
    "
    [shouldSwipeDownToClose]="true"
    [overflowY]="true"
    [containerClasses]="isMobile ? '!px-2 !pt-3 !pb-2' : '!p-3'"
  >
    <app-send-work
      [item]="item"
      [items]="modalItems"
      [modalId]="currentModalId"
    ></app-send-work>
  </app-modal>
  } @if (item | guardType: hasStreaming; as streamingWork) { @if (
  currentModalId === 'streaming_' + streamingWork._id &&
  worksService.streamingServices(streamingWork) ) {
  <app-modal
    [modalId]="'streaming_' + streamingWork._id"
    [classes]="
      isMobile
        ? '!h-auto bottom-0 rounded-t-lg'
        : '!h-[550px] max-w-[550px] !rounded-lg'
    "
    [shouldSwipeDownToClose]="true"
  >
    <app-display-streaming-options
      class="block mt-1 mb-[12px] pb-6"
      [item]="streamingWork"
      [user]="user"
    ></app-display-streaming-options>
  </app-modal>
  } } @if (saga) { @if (saga | guardType: isGameSeries; as gameSeries) { @if
  (currentModalId === 'game_series_' + gameSeries._id) {
  <app-modal
    [modalId]="'game_series_' + gameSeries._id"
    [classes]="
      isMobile
        ? '!h-[80%] bottom-0 rounded-t-lg !z-[100]'
        : '!h-[630px] max-w-[780px]'
    "
    [overflowY]="true"
    [shouldSwipeDownToClose]="true"
  >
    <app-work-game-series
      class="block"
      [saga]="gameSeries"
      [user]="user!"
    ></app-work-game-series>
  </app-modal>
  } } } @if (currentRecommendation) { @if (currentModalId === 'comment_' +
  currentRecommendation.friend.username) {
  <app-modal
    [modalId]="'comment_' + currentRecommendation.friend.username"
    [classes]="
      isMobile
        ? '!h-[33%] bottom-0 rounded-t-lg !z-[100]'
        : '!h-[300px] max-w-[660px] !z-[100]'
    "
    [overflowY]="true"
    [shouldSwipeDownToClose]="true"
  >
    <h2 class="ml-0!">
      {{ "RECOMMENDATION_FROM" | translate }}
      {{ currentRecommendation.friend.username }} -
      {{ currentRecommendation.additionDate | date: "dd/MM/yyyy" }}
    </h2>
    <h3 class="inline-block text-primary">
      {{ item ? worksService.getItemTitle(item) : "" }}
    </h3>
    <p class="mt-0 italic">
      {{ currentRecommendation.comment }}
    </p>
  </app-modal>
  } } @if (currentModalId === 'addList_' + item.providerId) {
  <app-modal
    classes="!z-80"
    [modalId]="'addList_' + item.providerId"
    [classes]="
      isMobile
        ? '!h-auto bottom-0 rounded-t-lg'
        : '!h-auto !max-w-[460px] !rounded-lg'
    "
    [shouldSwipeDownToClose]="true"
  >
    <app-add-to-list
      [user]="user!"
      [item]="item"
      [items]="modalItems"
      [inModal]="true"
    ></app-add-to-list>
  </app-modal>
  } } }
  <img
    class="w-0 h-0 opacity-0"
    src="/assets/images/icons/offline.svg"
    [alt]="'CURRENTLY_OFFLINE' | translate"
  />
  <app-compass-results-loading-overlay></app-compass-results-loading-overlay>
  <app-recommendation-discussion-host></app-recommendation-discussion-host>

  <div
    class="toast-container w-[75%] max-w-[460px] mobile:w-[460px] !z-[150] fixed left-1/2 -translate-x-2/4 bottom-4 mobile:left-auto mobile:translate-x-0 mobile:right-4 flex flex-col gap-2"
  >
    @if (!online) {
    <app-toast
      [message]="'CURRENTLY_OFFLINE'"
      [offline]="true"
      [@fadeInOut]
    ></app-toast>
    } @let visibleToasts = toasts().slice(-maxVisibleToastLayers); @if
    (visibleToasts.length) {
    <div class="relative isolate w-full">
      @for (toast of visibleToasts; track toast) { @let stackDepth =
      visibleToasts.length - $index - 1;
      <div
        class="block w-full transition-opacity duration-150"
        [ngClass]="{
          'relative z-30': stackDepth === 0,
          'absolute inset-x-0 bottom-2 z-20 h-full overflow-hidden rounded-lg opacity-80 pointer-events-none':
            stackDepth === 1,
          'absolute inset-x-0 bottom-4 z-10 h-full overflow-hidden rounded-lg opacity-60 pointer-events-none':
            stackDepth === 2
        }"
        [attr.aria-hidden]="stackDepth > 0 ? 'true' : null"
        [attr.inert]="stackDepth > 0 ? '' : null"
      >
        <app-toast
          class="block w-full"
          [toast]="toast"
          [message]="toast.text"
          [classes]="toast.classes"
          [translatable]="toast.translatable ?? true"
        ></app-toast>
      </div>
      }
    </div>
    }
  </div>
</main>
